<script setup lang="ts">
import { ref, onMounted, computed } from 'vue';
import InputText from 'primevue/inputtext'
import type { Yarn } from '@/types/yarn-types'
import { getYarnsList } from '@/api/yarns'
import InputNumber from 'primevue/inputnumber'
import { type Batch, type BatchMerge } from '@/types/batch-types'
import router from '@/router'
import { getBatchById } from '@/api/batches'

const props = defineProps<{
  batchMerges?: BatchMerge[],
  class?: string,
}>();

const batchId = router.currentRoute.value.params.id as string;
const batch = ref<Batch>();
const merges = ref<Yarn[]>([])

onMounted(async () => {
  batch.value =  await getBatchById(batchId)
  merges.value =  await getYarnsList()
})

const mergeNumbers = computed( () => {
  return batch.value?.batchMerges?.map((bm) => getMergeNumber(bm.mergeId)) || []
})

const getMergeNumber = (mergeId: string)  => {
   const merge = merges.value.find((merge) => merge.id === mergeId)
   return merge ? merge.mergeNumber :  'Unknown merge number'
}

</script>

<template>
  <div v-for="(merge, index) in batch?.batchMerges" :key="index" :class="props.class">
    <div class="grid grid-cols-3 gap-10">
      <div class="flex flex-col gap-2">
        <label for="mergeNumber" class="text-sm">Selected Merge Number:</label>
        <InputText
          id="mergeNumber"
          v-model="mergeNumbers[index]"
          placeholder="Enter new batch number here"
          disabled
        />
      </div>

      <div class="flex flex-col gap-2">
        <label for="kiloOfYarnUsed" class="text-sm">Kilos of Yarn Used:</label>
        <InputNumber
          id="kiloOfYarnUsed"
          disabled
          v-model="merge.kiloOfYarnUsed"
          placeholder="Enter kilo of yarn used"
        />
      </div>

      <div class="flex flex-col gap-2">
        <label for="kiloOfYarnWasted" class="text-sm">Kilos of Yarn Wasted:</label>
        <InputNumber
          id="kiloOfYarnWasted"
          disabled
          placeholder="Enter kilo of yarn wasted"
          v-model="merge.kiloOfYarnWasted"
        />
      </div>
    </div>
  </div>
</template>
